import React from "react";
import styles from "./TabsComponent.module.scss";
interface TabsProps {
  tabItems: { CategoryName: string; CategoryId: string; content: any }[];
  activeItem: string;
  onTabChange: (slug: string) => void;
  isTabAlignLeft?: boolean;
  products?: any;
}

const TabsComponent: React.FC<TabsProps> = (props: TabsProps) => {
  const { tabItems, activeItem, onTabChange, isTabAlignLeft, products } = props;

  return (
    <section className={`${styles.root} `}>
      {" "}
      <>
        {" "}
        {!!tabItems?.length && (
          <div className={`${styles.tabsWrapper} ${isTabAlignLeft ? styles.isTabAlignLeft : ""}`}>
            {" "}
            {tabItems.map(({ CategoryId, CategoryName }) => {
              const isActive = activeItem === CategoryId;

              return (
                <button
                  type={"button"}
                  onClick={() => onTabChange(CategoryId)}
                  key={CategoryId}
                  className={`${styles.tab} ${isActive ? styles.active : ""} `}
                >
                  {CategoryName}
                </button>
              );
            })}{" "}
          </div>
        )}{" "}
        {/* Tab Content */} <div className={styles.tabContent}>{products}</div>{" "}
      </>{" "}
    </section>
  );
};

export default TabsComponent;
